module.exports = __webpack_public_path__ + "img/symbol_8.5aaa5797.png";